import _slicedToArray from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.number.constructor.js";
import { defineComponent, ref, onMounted, provide, readonly, onBeforeUnmount } from 'vue';
import dayjs from 'dayjs';
// import { useEmptyStringFormat } from '@/hooks/fn'
import localCache from '@/utils/localCache';
import { useRoute } from 'vue-router';
import CTypeTab from '@/components/CTypeTab.vue';
import usePurchaseData from './hooks/usePurchaseData';
import CNoData from '@/components/CNoData.vue';
export default defineComponent({
  name: 'ReportDetail',
  components: {
    CTypeTab: CTypeTab,
    CNoData: CNoData
  },
  setup: function setup() {
    var formatDate = function formatDate(date) {
      return dayjs(date).format('YYYY/MM/DD');
    };
    var route = useRoute();
    var reportType = ref('aggregate');
    var dateType = ref(0);
    var params = ref({
      date: dayjs().format('YYYY/MM/DD'),
      type: 0,
      pageNumber: 1,
      pageSize: 10
    });
    if (route.params.reportType) {
      localCache.setItem('defaultReportType', route.params.reportType);
    }
    if (route.params.type) {
      localCache.setItem('defaultDateType', route.params.type);
    }
    var localCacheReportType = localCache.getItem('defaultReportType');
    if (localCacheReportType) {
      reportType.value = localCacheReportType;
    }
    var localCacheDateType = localCache.getItem('defaultDateType');
    if (localCacheDateType) {
      dateType.value = Number(localCacheDateType);
    }
    if (dateType.value) {
      params.value.type = dateType.value;
      if (dateType.value === 4) {
        params.value.date = dayjs().format('YYYY/MM/DD') + ',' + dayjs().format('YYYY/MM/DD');
      } else {
        params.value.date = dayjs().format('YYYY/MM/DD');
      }
    }
    provide('defaultDateType', readonly(dateType));
    onBeforeUnmount(function () {
      localCache.deleteItem('defaultDateType');
    });
    var confrimDate = function confrimDate(val) {
      params.value.date = val;
      params.value.pageNumber = 1;
      list.value = [];
      finished.value = false;
      loading.value = false;
      getDetailAsync();
    };
    var dateRef = ref();
    var confirmType = function confirmType(val) {
      var _dateRef$value;
      params.value.type = val;
      //把所以日期控件的日期变为当前最新日期
      (_dateRef$value = dateRef.value) === null || _dateRef$value === void 0 || _dateRef$value.reset();
      if (val === 4) {
        params.value.date = dayjs().format('YYYY/MM/DD') + ',' + dayjs().format('YYYY/MM/DD');
      } else {
        params.value.date = dayjs().format('YYYY/MM/DD');
      }
      params.value.pageNumber = 1;
      list.value = [];
      finished.value = false;
      loading.value = false;
      getDetailAsync();
    };
    var _usePurchaseData = usePurchaseData(params, reportType),
      _usePurchaseData2 = _slicedToArray(_usePurchaseData, 6),
      totalData = _usePurchaseData2[0],
      list = _usePurchaseData2[1],
      loading = _usePurchaseData2[2],
      finished = _usePurchaseData2[3],
      getDetailAsync = _usePurchaseData2[4],
      onLoad = _usePurchaseData2[5];
    onMounted(function () {
      getDetailAsync();
    });
    return {
      params: params,
      confirmType: confirmType,
      confrimDate: confrimDate,
      list: list,
      loading: loading,
      finished: finished,
      onLoad: onLoad,
      reportType: reportType,
      dateType: dateType,
      totalData: totalData,
      formatDate: formatDate,
      dateRef: dateRef
    };
  }
});